<template>
  <v-container>
    <app-splash/>
    <v-row justify="center">
      <v-col v-if="showLinks" cols="12" sm="6" md="4" lg="3">
        <v-card height="100%">
          <v-card-title style="text-align:center;" class="pb-0 mb-0">
            <h3 style="width:100%" class="text-h5 mb-0 font-weight-medium">
              <v-icon large color="primary darken-1" class="mb-4">fas fa-link</v-icon><br/>
              {{ $t('home.links') }}
            </h3>
          </v-card-title>
          <v-card-text class="pt-4">
            <v-divider class="mb-4"/>
            <ul>
              <li v-for="link in staticLinks" :key="link.staticLinkID" class="pb-4">
                <a :href="link.linkURL" target="_blank" style="font-size:1.1em">
                  {{ link.linkName }}
                </a>
              </li>
            </ul>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col class="d-flex" cols="12" :sm="showLinks ? 6 : 12" :md="showLinks ? 8 : 12" :lg="showLinks ? 9 : 12">
        <v-row style="margin-top:-12px;margin-bottom:-12px">
          <v-col v-if="hasAccess(value.componentID, $PACONST.PERMISSION_TYPES.READ)"
                 cols="12" :sm="showLinks ? 12 : 6" :md="showLinks ? 6 : 4" :lg="showLinks ? 4 : 3"
                 v-for="(value, key) in $PACONST.searchTypes"
                 :key="key">
            <search-card :search-type="key" :icon="value.icon"/>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import AppSplash from '@viewsupport/AppSplash';
import SearchCard from '@viewsupport/SearchCard';
import { mapGetters } from 'vuex';
import sortBy from 'lodash/sortBy';

export default {
  components: { AppSplash, SearchCard },
  data () {
    return {
      staticLinks: []
    };
  },
  computed: {
    ...mapGetters('user', ['hasAccess']),
    _pageTitle () {
      return this.$t('home.title');
    },
    showLinks () {
      return this.hasAccess(this.$PACONST.COMPONENT_STATIC_LINKS, this.$PACONST.PERMISSION_TYPES.READ);
    }
  },
  methods: {
    getLinks () {
      let url = this.$cove.getAPI({ name: 'api.staticLinks' });
      this.$axios.get(url).then((response) => {
        this.staticLinks = [];
        let sortedResponse = sortBy(response.data, 'orderBy');
        for (let i = 0; i < sortedResponse.length; i++) {
          let link = Object.assign({}, sortedResponse[i]);
          this.staticLinks.push(link);
        }
      });
    }
  },
  beforeRouteEnter (to, from, next) {
    next((vm) => {
      if (vm.hasAccess(vm.$PACONST.COMPONENT_STATIC_LINKS, vm.$PACONST.PERMISSION_TYPES.READ)) {
        vm.getLinks();
      }
    });
  }
};
</script>
